// packages/ag-charts-locale/src/pl-PL.ts
var AG_CHARTS_LOCALE_PL_PL = {
  ariaAnnounceChart: "wykres, ${seriesCount}[number] serii",
  ariaAnnounceFlowProportionLink: "link ${index} z ${count}, od ${from} do ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "w\u0119ze\u0142 ${index} z ${count}, ${description}",
  ariaAnnounceGaugeChart: "wykres wska\u017Anikowy, ${caption}",
  ariaAnnounceHierarchyChart: "wykres hierarchii, ${caption}",
  ariaAnnounceHierarchyDatum: "poziom ${level}[number], ${count}[number] dzieci, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Naci\u015Bnij Spacj\u0119 lub Enter, aby prze\u0142\u0105cza\u0107 widoczno\u015B\u0107",
  ariaLabelAddHorizontalLine: "Dodaj lini\u0119 poziom\u0105",
  ariaLabelAnnotationOptionsToolbar: "Opcje Adnotacji",
  ariaLabelAnnotationSettingsDialog: "Ustawienia Adnotacji",
  ariaLabelColorPicker: "Wyb\xF3r koloru",
  ariaLabelFinancialCharts: "Wykresy finansowe",
  ariaLabelLegend: "Legenda",
  ariaLabelLegendItem: "${label}, Element legendy ${index}[number] z ${count}[number]",
  ariaLabelLegendItemUnknown: "Nieznany element legendy",
  ariaLabelLegendPageNext: "Nast\u0119pna strona legendy",
  ariaLabelLegendPagePrevious: "Poprzednia strona legendy",
  ariaLabelLegendPagination: "Stronicowanie legendy",
  ariaLabelNavigator: "Nawigator",
  ariaLabelNavigatorMaximum: "Maksimum",
  ariaLabelNavigatorMinimum: "Minimum",
  ariaLabelNavigatorRange: "Zakres",
  ariaLabelRangesToolbar: "Zakresy",
  ariaLabelSettingsTabBar: "Ustawienia",
  ariaLabelZoomToolbar: "Powi\u0119kszenie",
  ariaValuePanRange: "${min}[percent0to2dp] do ${max}[percent0to2dp]",
  contextMenuDownload: "Pobierz",
  contextMenuPanToCursor: "Przesu\u0144 do tutaj",
  contextMenuToggleOtherSeries: "Prze\u0142\u0105cz inne serie",
  contextMenuToggleSeriesVisibility: "Prze\u0142\u0105cz widoczno\u015B\u0107",
  contextMenuZoomToCursor: "Powi\u0119ksz tutaj",
  dialogHeaderChannel: "Kana\u0142",
  dialogHeaderDatePriceRange: "Data i Cena",
  dialogHeaderDateRange: "Zakres dat",
  dialogHeaderFibonacciRange: "Fib Odpowiednio\u015B\u0107",
  dialogHeaderLine: "Linia",
  dialogHeaderPriceRange: "Zakres cenowy",
  dialogHeaderText: "Tekst",
  dialogInputAlign: "Wyr\xF3wnaj",
  dialogInputColorPicker: "Kolor",
  dialogInputColorPickerAltText: "Kolor tekstu",
  dialogInputExtendAbove: "Rozszerz powy\u017Cej",
  dialogInputExtendBelow: "Rozszerz poni\u017Cej",
  dialogInputExtendChannelEnd: "Przed\u0142u\u017C zako\u0144czenie kana\u0142u",
  dialogInputExtendChannelStart: "Rozszerz pocz\u0105tek kana\u0142u",
  dialogInputExtendLeft: "Rozci\u0105gnij w lewo",
  dialogInputExtendLineEnd: "Przed\u0142u\u017C zako\u0144czenie linii",
  dialogInputExtendLineStart: "Przed\u0142u\u017C pocz\u0105tek linii",
  dialogInputExtendRight: "Rozszerz w prawo",
  dialogInputFibonacciBands: "Pasma",
  dialogInputFibonacciBandsAltText: "Pasma Fibonacciego",
  dialogInputFillColorPicker: "Wype\u0142nij",
  dialogInputFillColorPickerAltText: "Kolor wype\u0142nienia",
  dialogInputFontSize: "Rozmiar",
  dialogInputFontSizeAltText: "Rozmiar czcionki",
  dialogInputLineStyle: "Kreska",
  dialogInputPosition: "Pozycja",
  dialogInputReverse: "Odwr\xF3\u0107",
  dialogInputShowFill: "Poka\u017C wype\u0142nienie",
  dialogInputStrokeWidth: "Grubo\u015B\u0107",
  dialogInputStrokeWidthAltText: "Grubo\u015B\u0107 linii",
  iconAltTextAlignCenter: "Wy\u015Brodkuj",
  iconAltTextAlignLeft: "Lewo",
  iconAltTextAlignRight: "Prawo",
  iconAltTextClose: "Zamknij",
  iconAltTextLineStyleDashed: "D\u0142ugie kreski",
  iconAltTextLineStyleDotted: "Kr\xF3tka kreska",
  iconAltTextLineStyleSolid: "Solid",
  iconAltTextPositionBottom: "D\xF3\u0142",
  iconAltTextPositionCenter: "\u015Arodek",
  iconAltTextPositionTop: "G\xF3ra",
  inputTextareaPlaceholder: "Dodaj Tekst",
  measurerDateRangeBars: "${value}[number] s\u0142upk\xF3w",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Obj\u0119to\u015B\u0107 ${value}",
  overlayLoadingData: "\u0141adowanie danych...",
  overlayNoData: "Brak danych do wy\u015Bwietlenia",
  overlayNoVisibleSeries: "Brak widocznych serii",
  overlayUnsupportedBrowser: "Niekompatybilna wersja przegl\u0105darki. Prosz\u0119 zaktualizowa\u0107 przegl\u0105dark\u0119.",
  seriesHistogramTooltipCount: "${yName} (liczba)",
  seriesHistogramTooltipFrequency: "Cz\u0119stotliwo\u015B\u0107",
  seriesHistogramTooltipMean: "${yName} (\u015Brednia)",
  seriesHistogramTooltipSum: "${yName} (suma)",
  toolbarAnnotationsArrow: "Strza\u0142ka",
  toolbarAnnotationsArrowDown: "Strza\u0142ka w d\xF3\u0142",
  toolbarAnnotationsArrowUp: "Strza\u0142ka w g\xF3r\u0119",
  toolbarAnnotationsCallout: "Adnotacja",
  toolbarAnnotationsClearAll: "Wyczy\u015B\u0107 wszystkie",
  toolbarAnnotationsComment: "Komentarz",
  toolbarAnnotationsDatePriceRange: "Data i cena",
  toolbarAnnotationsDateRange: "Zakres dat",
  toolbarAnnotationsDelete: "Usu\u0144",
  toolbarAnnotationsDisjointChannel: "Roz\u0142\u0105czony kana\u0142",
  toolbarAnnotationsDragHandle: "Przeci\u0105gnij pasek narz\u0119dzi",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib Odbicie",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Trend Based' oparty na trendzi",
  toolbarAnnotationsFillColor: "Kolor wype\u0142nienia",
  toolbarAnnotationsHorizontalLine: "Linia pozioma",
  toolbarAnnotationsLineAnnotations: "Linie Trendu",
  toolbarAnnotationsLineColor: "Kolor linii",
  toolbarAnnotationsLineStrokeWidth: "Grubo\u015B\u0107 linii",
  toolbarAnnotationsLineStyle: "Styl linii",
  toolbarAnnotationsLock: "Zablokuj",
  toolbarAnnotationsMeasurerAnnotations: "Mierniki",
  toolbarAnnotationsNote: "Notatka",
  toolbarAnnotationsParallelChannel: "Kana\u0142 r\xF3wnoleg\u0142y",
  toolbarAnnotationsPriceRange: "Zakres cen",
  toolbarAnnotationsQuickDatePriceRange: "Zmierz",
  toolbarAnnotationsSettings: "Ustawienia",
  toolbarAnnotationsShapeAnnotations: "Strza\u0142ki",
  toolbarAnnotationsText: "Tekst",
  toolbarAnnotationsTextAnnotations: "Adnotacje tekstowe",
  toolbarAnnotationsTextColor: "Kolor tekstu",
  toolbarAnnotationsTextSize: "Rozmiar tekstu",
  toolbarAnnotationsTrendLine: "Linia trendu",
  toolbarAnnotationsUnlock: "Odblokuj",
  toolbarAnnotationsVerticalLine: "Linia pionowa",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 miesi\u0105c",
  toolbarRange1Year: "1R",
  toolbarRange1YearAria: "1 rok",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 miesi\u0105ce",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 miesi\u0119cy",
  toolbarRangeAll: "Wszystko",
  toolbarRangeAllAria: "Wszystko",
  toolbarRangeYearToDate: "Rok Do Dzi\u015B",
  toolbarRangeYearToDateAria: "Od pocz\u0105tku roku",
  toolbarSeriesTypeCandles: "\u015Awiece",
  toolbarSeriesTypeDropdown: "Typ wykresu",
  toolbarSeriesTypeHighLow: "Wysoki Niski",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "\u015Awieczki Puste",
  toolbarSeriesTypeLine: "Linia",
  toolbarSeriesTypeLineWithMarkers: "Linia z znacznikami",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Linia krokowa",
  toolbarZoomPanEnd: "Przesu\u0144 na koniec",
  toolbarZoomPanLeft: "Przesu\u0144 w lewo",
  toolbarZoomPanRight: "Przesu\u0144 w prawo",
  toolbarZoomPanStart: "Przesu\u0144 na pocz\u0105tek",
  toolbarZoomReset: "Resetuj powi\u0119kszenie",
  toolbarZoomZoomIn: "Powi\u0119ksz",
  toolbarZoomZoomOut: "Oddal",
  tooltipPaginationStatus: "${index}[number] z ${count}[number]"
};
export {
  AG_CHARTS_LOCALE_PL_PL
};
//# sourceMappingURL=pl-PL.esm.mjs.map
